"use client";

import dynamic from "next/dynamic";

const PaintBoothStudioDemoView = dynamic(() => import("@/views/PaintBoothStudioDemo"), {
  ssr: false,
});

// Ungated demo — see PaintBoothDemoRoute for rationale. The view self-gates
// save/export and prompts logged-out visitors to create an account.
export function PaintBoothStudioDemoRoute() {
  return <PaintBoothStudioDemoView />;
}
